import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "three-people",
  "use": "three-people-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"three-people\"><path d=\"M26.39 9.36a5 5 0 10-4.78 0A8 8 0 0016.26 15a2.3 2.3 0 00-.26 0 5 5 0 00-2.84.89 7.94 7.94 0 00-2.77-1.53 5 5 0 10-4.78 0A8 8 0 000 22h2a6 6 0 016-6 5.94 5.94 0 013.78 1.34 4.94 4.94 0 001.83 7A8 8 0 008 32h2a6 6 0 0112 0h2a8 8 0 00-5.61-7.64 5 5 0 00-.2-8.83A6 6 0 0130 17h2a8 8 0 00-5.61-7.64zM8 7a3 3 0 11-3 3 3 3 0 013-3zm8 16a3 3 0 113-3 3 3 0 01-3 3zm8-21a3 3 0 11-3 3 3 3 0 013-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/three-people.svg
// module id = oSl7
// module chunks = 38 43